export const clientPackageDetailsMealSlotModel = (
	mealSlot: IClientPackageDetailsMealSlot,
): IClientPackageDetailsMealSlotModel => {
	const {
		diet_type,
		meal_type,
		meal_kind,
		meal_subkind,
		size_id,
		is_selected,
		variant_id,
		meal_id,
		meal_category,
		is_core,
		meal_price_tier,
		selection_source,
		paid_price,
		meal_slot,
		sell_price,
		...rest
	} = mealSlot

	return {
		...rest,
		dietType: diet_type,
		mealType: meal_type,
		mealKind: meal_kind,
		mealSubkind: meal_subkind,
		sizeID: size_id,
		isSelected: is_selected,
		variantID: variant_id,
		mealID: meal_id,
		mealCategory: meal_category,
		isCore: is_core,
		mealPriceTier: meal_price_tier,
		selectionSource: selection_source,
		paidPrice: paid_price,
		mealSlot: meal_slot ? clientPackageDetailsMealSlotModel(meal_slot) : null,
		sellPrice: sell_price,
	}
}

export const clientPackageDetailsItemModel = (item: IClientPackageDetailsItem): IClientPackageDetailsItemModel => {
	const { meal_packaging_assignment_id, meal_slot_id, addon_client_diet_day_id, meal_slot, ...rest } = item

	return {
		...rest,
		mealPackagingAssignmentID: meal_packaging_assignment_id,
		mealSlotID: meal_slot_id,
		addonClientDietDayID: addon_client_diet_day_id,
		mealSlot: clientPackageDetailsMealSlotModel(meal_slot),
	}
}

export const clientPackageDetailsCurrentConfigDietModel = (
	currentConfigDiet: IClientPackageDetailsCurrentConfigDiet,
): IClientPackageDetailsCurrentConfigDietModel => {
	const { diet_id, name, diet_type, diet_group } = currentConfigDiet

	return {
		dietID: diet_id,
		name: LangContentToModel(name),
		dietType: diet_type,
		dietGroup: diet_group,
	}
}

export const clientPackageDetailsDietModel = (diet: IClientPackageDetailsDiet): IClientPackageDetailsDietModel => {
	const { current_config_diet, ...rest } = diet

	const baseDiet = clientPackageDietModel(rest as IClientPackageDiet)

	return {
		...baseDiet,
		currentConfigDiet: current_config_diet ? clientPackageDetailsCurrentConfigDietModel(current_config_diet) : null,
	}
}

export const clientPackageDetailsDietDayBaseModel = (
	clientDietDay: IClientPackageDetailsDietDayBase,
): IClientPackageDetailsDietDayBaseModel => ({
	id: clientDietDay.id,
	uuid: clientDietDay.uuid,
	date: new Date(clientDietDay.date),
	allMealsSelected: clientDietDay.all_meals_selected,
	status: clientDietDay.status,
	cartDietDayID: clientDietDay.cart_diet_day_id,
	addressID: clientDietDay.address_id,
	kcal: clientDietDay.kcal,
	dietID: clientDietDay.diet_id,
	dietLabel: clientDietDay.diet_label,
	dietType: clientDietDay.diet_type,
	paidPrice: clientDietDay.paid_price,
	paidCorePrice: clientDietDay.paid_core_price,
	paidDeliveryPrice: clientDietDay.paid_delivery_price,
	address: clientPackageAddressModel(clientDietDay.address),
})

export const clientPackageDetailsDietDayModel = (
	clientDietDay: IClientPackageDetailsDietDay,
): IClientPackageDetailsDietDayModel => {
	const { client_diet, ...rest } = clientDietDay

	const baseDietDay = clientPackageDetailsDietDayBaseModel(rest)

	return {
		...baseDietDay,
		clientDiet: clientPackageDetailsDietModel(client_diet),
	}
}

export const clientPackageDetailsModel = (clientPackageDetails: IClientPackageDetails): IClientPackageDetailsModel => {
	const {
		box_type,
		total_weight,
		visualisation_url,
		status_short,
		package_guid,
		region_identifier,
		region_forwarder,
		region_branch,
		box_packaging_items_count,
		total_value,
		items,
		client_diet_day,
		id,
		...rest
	} = clientPackageDetails

	return {
		...rest,
		id: id ?? 0,
		boxType: box_type,
		totalWeight: total_weight,
		visualisationUrl: visualisation_url,
		statusShort: status_short,
		packageGuid: package_guid,
		regionIdentifier: region_identifier,
		regionForwarder: region_forwarder,
		regionBranch: region_branch,
		boxPackagingItemsCount: box_packaging_items_count,
		totalValue: total_value,
		items: items.map(clientPackageDetailsItemModel),
		clientDietDay: clientPackageDetailsDietDayModel(client_diet_day),
	}
}
